import AuthenticateAccess from "./AuthenticateAccess";

export default AuthenticateAccess;